import React from 'react';
import PropTypes from 'prop-types';
import {AccordionItem} from '@/components/molecules';
import GameDisplayMetadataSection from './GameDisplayMetadataSection';

const GameDisplayAccordionItem = ({index, label, subTitle, metadataProps}) => (
  <AccordionItem
    isDark
    expanded
    index={index}
    label={label}
    onUpdate={() => {}}
    subTitle={subTitle}
    content={
      <div className='w-full'>
        <GameDisplayMetadataSection
          {...metadataProps}
          showSectionHeader={false}
        />
      </div>
    }
  />
);

GameDisplayAccordionItem.propTypes = {
  index: PropTypes.number,
  label: PropTypes.string,
  subTitle: PropTypes.string,
  metadataProps: PropTypes.object.isRequired
};

GameDisplayAccordionItem.defaultProps = {
  index: 0,
  label: 'Game Display',
  subTitle: 'How the game looks on PepsiConnect Games'
};

export default React.memo(GameDisplayAccordionItem);
